"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _dailySettlementStatement = require("@/api/financialManagement/dailySettlementStatement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BillingDetails',
  data: function data() {
    return {
      dialogVisible: false,
      tableData: [],
      queryData: {
        scene: 1,
        //	统计场景:0-月份(月结对账) 1-会员(会员明细)
        type: 1,
        //	统计方式:0-汇总 1-明细
        billDay: null,
        // 账单月份
        memberId: '',
        page: 1,
        size: 10
      },
      accountData: []
    };
  },
  methods: {
    // 用户详情
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.memberName
        }
      });
    },
    open: function open(val) {
      this.tableData = [val];
      this.queryData.billDay = val.billDay;
      this.queryData.memberId = val.memberId;
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.dialogVisible = true;
      this.listBillStatsPaged();
    },
    listBillStatsPaged: function () {
      var _listBillStatsPaged2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _dailySettlementStatement.listBillStatsPaged)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.accountData = res.data.data;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function listBillStatsPaged() {
        return _listBillStatsPaged2.apply(this, arguments);
      }
      return listBillStatsPaged;
    }(),
    handleClose: function handleClose() {
      this.dialogVisible = false;
    }
  }
};